export const environment = {
  production: false,
  // apiUrl: 'https://api.futamobile.com/',
  apiUrl: 'https://futa-api.herokuapp.com/',
  // apiUrl: 'http://localhost:3000/',
  inactivityTimeout: 1000 * 60 * 30
};
